export enum TextType {
    TOPIC = 'topic',
    CONTENT = 'content',
    QUOTE = 'quote',
}